<template>
  <div class="modal overflow-auto" select-cy="grant-roles-modal">
    <div class="card inner-large">
      <div class="header">
        <div class="title">
          <h2>Grant Roles</h2>
          <div class="loading" v-if="isUpdating">
            <img src="@/assets/img/loading-tail-spin.svg" />
          </div>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <div class="choice-tables">
          <div class="left">
            <h3>Available Roles</h3>
          </div>
          <div class="right">
            <h3>Granted Roles</h3>
          </div>
          <div class="left-table">
            <Table
              v-if="roles"
              :items="roles"
              :attributes="rolesTableAttributes"
              :options="rolesTableOptions"
              @edit="grant"
            ></Table>
          </div>
          <div class="right-table">
            <Table
              :items="grantedRoles"
              :attributes="rolesTableAttributes"
              :options="grantedTableOptions"
              @delete="revoke"
            ></Table>
          </div>
        </div>
      </div>

      <!-- Error Messages -->
      <Alert v-if="errorMessage" :message="errorMessage"></Alert>

      <div class="footer">
        <div class="flex-grow"></div>
        <button type="button" @click="close()">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ALERT_TYPE, MESSAGES, GRANT_ACTION, CONFIRM_COLOR } from '@/helpers/constants';
import { MODAL_NAME } from '../store';
import Alert from '@/components/Alert.vue';
import Table from '@/components/Table.vue';

export default {
  name: 'UserGrantRole',
  components: {
    Alert,
    Table,
  },

  data() {
    return {
      grantedRoles: [],
      roles: null,
      isUpdating: false,
      message: null,
      grantedTableOptions: {
        delete: true,
        deleteLabel: 'Revoke',
        discreet: true,
        pages: [10],
        showHeader: false,
      },
      rolesTableOptions: {
        edit: true,
        editLabel: 'Grant',
        discreet: true,
        pages: [10],
        showHeader: false,
      },
      rolesTableAttributes: [{ name: 'name', label: 'Name' }],
    };
  },
  computed: {
    item() {
      return this.$store.getters['users/getUser'];
    },
    errorMessage: {
      get() {
        return this.message;
      },
      set(value) {
        if (value === null) {
          this.message = null;
        } else {
          this.message = {
            content: value,
            type: ALERT_TYPE.ERROR,
          };
        }
      },
    },
  },

  created() {
    this.grantedRoles = [...this.item.roles];
    this.fetchRoles();
  },

  methods: {
    close() {
      this.$store.dispatch('users/get', {
        ids: this.item.id,
        includeRoles: true,
        includePermissions: true,
        detailedPermissions: true,
      });
      this.$store.commit('users/close', MODAL_NAME.GRANT_ROLE);
    },
    fetchRoles() {
      this.$store
        .dispatch('users/getRoles')
        .then(({ data }) => {
          this.roles = data.filter((e) => !this.grantedRoles.find((f) => f.id === e.id));
          this.sortArrays();
        })
        .catch((err) => {
          console.error(err);
          this.errorMessage = MESSAGES.SERVER_ERROR;
          this.roles = [];
        });
    },
    grant(role) {
      if (this.isUpdating) return;
      this.errorMessage = null;
      this.isUpdating = true;

      const payload = {
        userId: this.item.id,
        roleId: role.id,
        action: GRANT_ACTION.GRANT,
      };
      this.$store
        .dispatch('users/updateRole', [payload])
        .then(() => {
          this.grantedRoles.push(role);
          this.roles.splice(
            this.roles.findIndex((e) => e.id === role.id),
            1,
          );
          this.sortArrays();
        })
        .catch((err) => {
          console.error(err);
          if (err && err.status && err.status === 401) {
            this.errorMessage = MESSAGES.NO_PERMISSION;
          } else {
            this.errorMessage = MESSAGES.SERVER_ERROR;
          }
        })
        .finally(() => (this.isUpdating = false));
    },
    revoke(role) {
      if (this.isUpdating) return;
      this.errorMessage = null;
      this.isUpdating = true;

      this.$store
        .dispatch('confirm/confirm', {
          color: CONFIRM_COLOR.DANGER,
          details: `Would you like to revoke the "${role.name}" role?`,
        })
        .then((res) => {
          if (res) {
            const payload = {
              userId: this.item.id,
              roleId: role.id,
              action: GRANT_ACTION.REVOKE,
            };
            this.$store
              .dispatch('users/updateRole', [payload])
              .then(() => {
                this.roles.push(role);
                this.grantedRoles.splice(
                  this.grantedRoles.findIndex((e) => e.id === role.id),
                  1,
                );
                this.sortArrays();
              })
              .catch((err) => {
                console.error(err);
                if (err && err.status && err.status === 401) {
                  this.errorMessage = MESSAGES.NO_PERMISSION;
                } else {
                  this.errorMessage = MESSAGES.SERVER_ERROR;
                }
              })
              .finally(() => (this.isUpdating = false));
          } else {
            this.isUpdating = false;
          }
        });
    },

    sortArrays() {
      if (this.roles) {
        // This will force the refresh the table component with the new order
        this.roles = [
          ...this.roles.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            else return 0;
          }),
        ];
      }
      if (this.grantedRoles) {
        this.grantedRoles = [
          ...this.grantedRoles.sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            else return 0;
          }),
        ];
      }
    },
  },
};
</script>